import React from 'react';
import { Cn, De, El, En, Es, Hu, It, Ja, Ko, Ru } from "../icons";
export var defaultLanguages = ['en', 'ru', 'zh', 'it', 'de', 'es', 'ja', 'ko', 'hu'];
export var langs = [{
  choose: 'Choose language',
  locale: 'en',
  title: 'English',
  flag: /*#__PURE__*/React.createElement(En, {
    size: "md"
  })
}, {
  choose: 'Выберите язык',
  locale: 'ru',
  title: 'Русский',
  flag: /*#__PURE__*/React.createElement(Ru, {
    size: "md"
  })
}, {
  choose: '选择语言',
  locale: 'zh',
  title: '中文',
  flag: /*#__PURE__*/React.createElement(Cn, {
    size: "md"
  })
}, {
  choose: 'Sprache wählen',
  locale: 'de',
  title: 'Deutsch',
  flag: /*#__PURE__*/React.createElement(De, {
    size: "md"
  })
}, {
  choose: 'idioma',
  locale: 'es',
  title: 'Español',
  flag: /*#__PURE__*/React.createElement(Es, {
    size: "md"
  })
}, {
  choose: 'Scegli la lingua',
  locale: 'it',
  title: 'Italiano',
  flag: /*#__PURE__*/React.createElement(It, {
    size: "md"
  })
}, {
  choose: 'Válassz nyelvet',
  locale: 'hu',
  title: 'Magyar',
  flag: /*#__PURE__*/React.createElement(Hu, {
    size: "md"
  })
}, {
  choose: '言語を選択してください',
  locale: 'ja',
  title: '日本語',
  flag: /*#__PURE__*/React.createElement(Ja, {
    size: "md"
  })
}, {
  choose: '언어 선택',
  locale: 'ko',
  title: '한국어',
  flag: /*#__PURE__*/React.createElement(Ko, {
    size: "md"
  })
}, {
  choose: 'Διάλεξε γλώσσα',
  locale: 'el',
  title: 'Ελληνικά',
  flag: /*#__PURE__*/React.createElement(El, {
    size: "md"
  })
}];